var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", attrs: { id: "panel-4" } },
    [
      _c("div", { staticClass: "panel-hdr" }, [
        _c("h2", [
          _vm._m(0),
          _vm._v("\n            " + _vm._s(_vm.__t("LIST")) + " "),
          _c("span", { staticClass: "fw-300" }, [
            _c("i", [_vm._v(_vm._s(_vm.__t("PRODUCTS")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
          _vm._v(" "),
          !_vm.is_load
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-icon btn-info shadow-0 waves-effect waves-themed mr-2 ml-2",
                  on: { click: _vm.add_stop },
                },
                [_c("i", { staticClass: "fal fa-blinds-open" })]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show" }, [
        _c(
          "div",
          { staticClass: "panel-content" },
          [
            _c(
              "div",
              { staticClass: "filter_block mb-3" },
              [_c("filter_stop")],
              1
            ),
            _vm._v(" "),
            _vm.is_load
              ? _c("b-skeleton-table", {
                  attrs: {
                    rows: _vm.cur_records,
                    columns: 2,
                    "hide-header": true,
                    "table-props": { bordered: false, striped: true },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.is_load
              ? _c(
                  "div",
                  { staticClass: "inbox_vue_list" },
                  [
                    _vm.rows.length > 0
                      ? _c(
                          "div",
                          { staticClass: "inb_pagi pt-4" },
                          [
                            _c("pagination_list", {
                              key: "up",
                              attrs: {
                                total: _vm.pagination.total,
                                limit: _vm.pagination.limit,
                                current: _vm.pagination.pagesCurrent,
                              },
                              on: { "page-change": _vm.handlePageChange },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.rows.length > 0
                      ? _c("b-table", {
                          staticClass: "table-responsive-xl resolution_table",
                          attrs: {
                            "tbody-tr-class": _vm.rowClass,
                            striped: "",
                            items: _vm.rows,
                            fields: _vm.fields,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-center text-danger my-2",
                                      },
                                      [
                                        _c("b-spinner", {
                                          staticClass: "align-middle",
                                        }),
                                        _vm._v(" "),
                                        _c("strong", [_vm._v("Work...")]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "head(id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.is_check_all,
                                              expression: "is_check_all",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            disabled: true,
                                            type: "checkbox",
                                            id: "imc_checker_all",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.is_check_all
                                            )
                                              ? _vm._i(_vm.is_check_all, null) >
                                                -1
                                              : _vm.is_check_all,
                                          },
                                          on: {
                                            click: _vm.check_all,
                                            change: function ($event) {
                                              var $$a = _vm.is_check_all,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.is_check_all =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.is_check_all = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.is_check_all = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass:
                                            "custom-control-label cursor-pointer bolder",
                                          attrs: { for: "imc_checker_all" },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(provider)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "status_info",
                                        staticStyle: { "max-width": "50px" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.__t("O_EXP_IC")) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(filename)",
                                fn: function (data) {
                                  return [
                                    _c("div", {
                                      staticClass: "fs-xl text-left",
                                      domProps: {
                                        innerHTML: _vm._s(data.label),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(title)",
                                fn: function (data) {
                                  return [
                                    _c("grid_list", {
                                      attrs: {
                                        list_ordering:
                                          "ksenmart_products.title",
                                        field_name: _vm.__t("TITLE"),
                                        current_ordering: _vm.list.ordering,
                                        current_direction: _vm.list.direction,
                                      },
                                      on: {
                                        "update-order": _vm.handleOrdering,
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(rest_id)",
                                fn: function (data) {
                                  return [
                                    _c("grid_list", {
                                      attrs: {
                                        list_ordering: "rest_id",
                                        field_name: _vm.__t(
                                          "ATTACHED_RESTAURANT"
                                        ),
                                        current_ordering: _vm.list.ordering,
                                        current_direction: _vm.list.direction,
                                      },
                                      on: {
                                        "update-order": _vm.handleOrdering,
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(location)",
                                fn: function (data) {
                                  return [
                                    _c("grid_list", {
                                      attrs: {
                                        list_ordering:
                                          "ksenmart_products_black_listed.rest_id",
                                        field_name:
                                          _vm.__t("ATTACHED_LOCATION"),
                                        current_ordering: _vm.list.ordering,
                                        current_direction: _vm.list.direction,
                                      },
                                      on: {
                                        "update-order": _vm.handleOrdering,
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(added)",
                                fn: function (data) {
                                  return [
                                    _c("grid_list", {
                                      attrs: {
                                        list_ordering: "added",
                                        field_name: _vm.__t("ADDED"),
                                        current_ordering: _vm.list.ordering,
                                        current_direction: _vm.list.direction,
                                      },
                                      on: {
                                        "update-order": _vm.handleOrdering,
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(client_id)",
                                fn: function (data) {
                                  return [
                                    _c("div", {
                                      staticClass: "fs-xl text-center",
                                      domProps: {
                                        innerHTML: _vm._s(data.label),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: data.item.published,
                                              expression: "data.item.published",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            name: "cid[]",
                                            type: "checkbox",
                                            id: data.item.id + "_cust_id",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              data.item.published
                                            )
                                              ? _vm._i(
                                                  data.item.published,
                                                  null
                                                ) > -1
                                              : data.item.published,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = data.item.published,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      data.item,
                                                      "published",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      data.item,
                                                      "published",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  data.item,
                                                  "published",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass:
                                            "custom-control-label cursor-pointer bolder",
                                          attrs: {
                                            for: data.item.id + "_cust_id",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(filename)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "img_block rounded" },
                                      [
                                        _vm.obj_to_null(data.item.image)
                                          ? _c("picture", [
                                              _c("source", {
                                                attrs: {
                                                  srcset: data.item.image.webp,
                                                  type: "image/webp",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("source", {
                                                attrs: {
                                                  srcset: data.item.image.jpeg,
                                                  type: "image/jpeg",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("img", {
                                                attrs: {
                                                  itemprop: "image",
                                                  src: data.item.image.jpeg,
                                                },
                                              }),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(provider)",
                                fn: function (data) {
                                  return [
                                    _vm.obj_to_null(data.item.aggregator)
                                      ? _c(
                                          "div",
                                          { staticClass: "provider_img" },
                                          [
                                            _c("div", { staticClass: "icon" }, [
                                              !_vm.obj_to_null(
                                                data.item.aggregator.icon
                                              )
                                                ? _c("i", {
                                                    staticClass:
                                                      "fal fa fa-file-o fa-file",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.obj_to_null(
                                                data.item.aggregator.icon
                                              )
                                                ? _c("span", {
                                                    staticClass:
                                                      "order_prov_image",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        data.item.aggregator
                                                          .icon
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.item.hasOwnProperty("aggregators")
                                      ? _c("aggregator-icons", {
                                          attrs: {
                                            aggregators: data.item.aggregators,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(title)",
                                fn: function (data) {
                                  return [
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-start w-100 fs-xl mb-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.open_item(data)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "base base-15 icon-stack-3x opacity-100 color-primary-900",
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fal fa-indent icon-stack-1x opacity-100 color-white",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.obj_to_null(data.item.product)
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                     " +
                                                    _vm._s(
                                                      data.item.product.title
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "\n                                    NOT_FOUND\n                                "
                                                ),
                                              ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-start w-100",
                                        },
                                        [
                                          data.item.hasOwnProperty("aggregator")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "small badge border border-success",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        data.item.aggregator
                                                          .type
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.obj_to_null(data.item)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "small badge border border-info",
                                                },
                                                [
                                                  data.item.is_prod
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.__t("CATEG:")
                                                          )
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.__t("GROUP:")
                                                          )
                                                        ),
                                                      ]),
                                                  _vm._v(
                                                    "\n\n                                    " +
                                                      _vm._s(
                                                        data.item.main_category
                                                          .title
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.obj_to_null(data.item)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ml-3 small badge border border-info",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        data.item.product_uniq
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.item.hasOwnProperty("restaurant")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ml-3 small badge border border-warning",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        data.item.restaurant
                                                          .title
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(rest_id)",
                                fn: function (data) {
                                  return [
                                    data.item.hasOwnProperty("restaurant")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "prod_name fs-xl color-success-600",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                                 " +
                                                  _vm._s(
                                                    data.item.restaurant.title
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "small text-info",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small badge border border-warning",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          data.item.restaurant
                                                            .uniq_id
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(location)",
                                fn: function (data) {
                                  return [
                                    data.item.hasOwnProperty("location")
                                      ? _c(
                                          "div",
                                          { staticClass: "prod_name fs-xl" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                                 " +
                                                  _vm._s(
                                                    data.item.location.title
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "small text-info",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small badge border border-warning",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          data.item.location
                                                            .uniq_id
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(added)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(data.item.added) +
                                        "\n                    "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(client_id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fs-xl cursor-pointer",
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove_stop(data.item)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fas fa-trash" })]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "row-details",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "stop_info" },
                                      [
                                        _c("StopItemInfo", {
                                          attrs: { item: row.item },
                                          on: { remove_stop: _vm.remove_stop },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1106285997
                          ),
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.rows.length > 0
                      ? _c(
                          "div",
                          { staticClass: "inb_pagi pt-4" },
                          [
                            _c("pagination_list", {
                              key: "down",
                              attrs: {
                                total: _vm.pagination.total,
                                limit: _vm.pagination.limit,
                                current: _vm.pagination.pagesCurrent,
                              },
                              on: { "page-change": _vm.handlePageChange },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex",
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-warning shadow-0 waves-effect waves-themed mr-2 ml-2",
                on: { click: _vm.refresh_stop },
              },
              [_vm._v("\n                Syrve Stop Sync\n            ")]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("add_stop"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "badge position-relative mr-2 fs-xl bg-none text-warning",
      },
      [_c("i", { staticClass: "fal fa-edit" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }